import { ClientsWithChildren } from "../../../service/Clients";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Card, CardContent, Pagination, Skeleton, Stack, TextField } from "@mui/material";
import { trackEventMatomo } from "../../../helpers/matomo";
import { useEffect, useState } from "react";
import usePagination from "../../Pagination/Pagination";

type conjunto = {
  id: string,
  nome: string
};

type local = {
  id: string,
  nome: string,
  conjuntosList: conjunto[],
};

type cliente = {
  id: string,
  nome: string,
  locaisList: local[]
};

type props = {
  isLoading: boolean
  clients: ClientsWithChildren[]
  tipoServico: string
  conjuntosArray: string[],
  setConjuntosArray: Function,
  disabled: boolean
};

export default function ServicePlacesAssociation({
  isLoading,
  clients,
  tipoServico,
  conjuntosArray,
  setConjuntosArray,
  disabled
}: props) {
  const [search, setSearch] = useState<string>('');
  const [paginated, setPaginated] = useState<cliente[]>([]);
  const [page, setPage] = useState(1);
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChangeExpand = (isExpanded: boolean, panel: string) => {
    setExpanded(isExpanded ? panel : false);
  };

  const PER_PAGE = 5;
  const count = Math.ceil(clients?.length / PER_PAGE);
  const _DATA = usePagination(clients?.sort((a: cliente, b: cliente) => { return a.nome > b.nome ? 1 : -1; }), PER_PAGE);

  useEffect(() => {
    search ? setPaginated(clients
      ?.filter((e: cliente) => e.nome
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.toLowerCase()
        ?.includes(search
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.toLowerCase()))) : setPaginated(_DATA.currentData());
  }, [search, page, isLoading]);

  const handleChange = (e: any, p: number) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>{
      isLoading
        ?
        <>
          <Stack
            width={'100%'}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Stack
              width={'100%'}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Skeleton variant="rounded" height={40} width={'15%'} />
              <Skeleton variant="rounded" height={40} width={'80%'} />
            </Stack>
            <Skeleton variant="rounded" height={60} width={'100%'} />
          </Stack>
        </>
        :
        <>{!clients?.length
          ? <Card sx={{ border: '1px solid orange' }}>
            <CardContent>
              <Typography color='GrayText' variant='subtitle1' textAlign='justify'>
                * Você não possui nenhuma estrutura geográfica
                associada a esse tipo,
                por favor associe em Gestão de
                Serviços na aba de Gestão de Local,
                ou em Gestão de Cliente na aba Meus Clientes.
              </Typography>
            </CardContent>
          </Card>
          :
          <>
            <SearchInput search={search} setSearch={setSearch} arrayLenght={clients?.length} name={'Clientes:'} />
            {paginated
              ?.sort((a: cliente, b: cliente) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
              ?.map((client: cliente, index: number) => (
                <ClientsAcordion
                  conjuntosArray={conjuntosArray}
                  setConjuntosArray={setConjuntosArray}
                  expanded={expanded}
                  setExpanded={handleChangeExpand}
                  client={client}
                  disabled={disabled}
                />
              ))}
            {(clients.length > 5 && !search)
              && <Pagination
                count={count}
                size="small"
                page={page}
                variant='text'
                shape='circular'
                onChange={handleChange}
              />}
          </>
        }
        </>
    }
    </>
  );
}



const ClientsAcordion = ({
  client,
  expanded,
  setExpanded,
  conjuntosArray,
  setConjuntosArray,
  disabled
}: {
  client: cliente,
  expanded: boolean | string,
  setExpanded: Function,
  conjuntosArray: string[],
  setConjuntosArray: Function,
  disabled: boolean
}) => {
  const [search, setSearch] = useState<string>('');
  const [paginated, setPaginated] = useState<local[]>([]);
  const [page, setPage] = useState(1);

  const [expandedLocal, setExpandedLocal] = useState<string | false>(false);

  const handleChangeExpand = (isExpanded: boolean, panel: string) => {
    setExpandedLocal(isExpanded ? panel : false);
  };

  const PER_PAGE = 5;
  const count = Math.ceil(client.locaisList?.length / PER_PAGE);
  const _DATA = usePagination(client.locaisList?.sort((a: local, b: local) => { return a.nome > b.nome ? 1 : -1; }), PER_PAGE);

  useEffect(() => {
    search ? setPaginated(client.locaisList
      ?.filter((e: local) => e.nome
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.toLowerCase()
        ?.includes(search
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.toLowerCase()))) : setPaginated(_DATA.currentData());
  }, [search, page]);

  const handleChange = (e: any, p: number) => {
    setPage(p);
    _DATA.jump(p);
  };

  const allSetsFromClient: string[] = [];
  client?.locaisList?.forEach((local: local) => {
    if(local?.conjuntosList?.length){
      local?.conjuntosList?.forEach((cnj: conjunto) => allSetsFromClient?.push(cnj.id));
    } else allSetsFromClient.push('Este local não tem conjuntos');
  });

  return (
    <>
      <Accordion
        key={client.id}
        sx={{ width: '100%' }}
        expanded={expanded === client.id}
      >
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon
            onClick={(isExpanded) => {
              trackEventMatomo('Gestão de formulários', 'click', 'accordeon', 'abre/fecha');
              if (expanded === client.id) {
                setExpanded(!isExpanded, '');
              } else
                setExpanded(true, client.id);
            }} />}
        >
          <Typography variant="h6">
            <FormGroup>
              <FormControlLabel
                control={<Checkbox
                  disabled={disabled}
                  checked={allSetsFromClient?.every(set => conjuntosArray.length > 0 &&  conjuntosArray?.includes(set) && set.length) || false}
                  onChange={(event) => {
                    const cnjs: string[] = [];
                    if (event.target.checked) {
                      client.locaisList?.forEach((local) => {
                        local.conjuntosList?.forEach((cnj) => {
                          setConjuntosArray((prev: string[]) => prev.length ? [...prev, cnj.id] : [cnj.id]);
                          cnjs?.push(cnj.id);
                        });
                      });
                    }
                    else {
                      client.locaisList?.forEach((local) => {
                        local.conjuntosList?.forEach((cnj) => {
                          setConjuntosArray((prev: string[]) => prev?.filter((el: any) => el !== cnj.id));
                          cnjs.push(cnj.id);
                        });
                      });
                    }
                  }} />}
                label={client.nome}
              />
            </FormGroup>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SearchInput search={search} setSearch={setSearch} arrayLenght={client.locaisList?.length} name={'Locais:'} />
          <Typography>
            {paginated
              ?.sort((a: local, b: local) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
              ?.map((local: local, index: number) => {
                const allSetsFromPlace: string[] = local?.conjuntosList?.map((cnj: conjunto) => cnj.id);
                return (
                  <LocaisAcordion
                    allSetsFromPlace={allSetsFromPlace}
                    expanded={expandedLocal}
                    setExpanded={handleChangeExpand}
                    local={local}
                    conjuntosArray={conjuntosArray}
                    setConjuntosArray={setConjuntosArray}
                    disabled={disabled}
                  />
                );
              })}
          </Typography>
          {(client.locaisList.length > 5 && !search)
            && <Stack
              width={'100%'}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Pagination
                count={count}
                size="small"
                page={page}
                variant='text'
                shape='circular'
                onChange={handleChange}
              />
            </Stack>}
        </AccordionDetails>
      </Accordion >
    </>
  );
};

const LocaisAcordion = ({
  local,
  conjuntosArray,
  setConjuntosArray,
  expanded,
  setExpanded,
  allSetsFromPlace,
  disabled
}: {
  local: any,
  conjuntosArray: string[]
  setConjuntosArray: Function,
  expanded: string | boolean,
  setExpanded: Function
  allSetsFromPlace: string[],
  disabled: boolean
}) => {
  const [search, setSearch] = useState<string>('');
  const [paginated, setPaginated] = useState<ClientsWithChildren[]>([]);
  const [page, setPage] = useState(1);

  const PER_PAGE = 5;
  const count = Math.ceil(local.conjuntosList?.length / PER_PAGE);
  const _DATA = usePagination(local.conjuntosList?.sort((a: any, b: any) => { return a.nome > b.nome ? 1 : -1; }), PER_PAGE);

  useEffect(() => {
    search ? setPaginated(local.conjuntosList
      ?.filter((e: conjunto) => e.nome
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.toLowerCase()
        ?.includes(search
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.toLowerCase()))) : setPaginated(_DATA.currentData());
  }, [search, page]);

  const handleChange = (e: any, p: number) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>
      <Accordion
        key={local.id}
        sx={{ width: '100%' }}
        expanded={expanded === local.id}
      >
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon onClick={(isExpanded) => {
            trackEventMatomo('Gestão de formulários', 'click', 'accordeon', 'abre/fecha');
            if (expanded === local.id) {
              setExpanded(!isExpanded, '');
            } else
              setExpanded(true, local.id);
          }} />}
        >
          <Typography variant="h6">
            <FormGroup>
              <FormControlLabel
                control={<Checkbox
                  disabled={disabled}
                  checked={allSetsFromPlace?.every(set => conjuntosArray.length > 0 && conjuntosArray?.includes(set) && set.length ) || false}
                  onChange={(event) => {
                    const cnjs: string[] = [];
                    if (event.target.checked) {
                      local.conjuntosList?.forEach((cnj: conjunto) => {
                        setConjuntosArray((prev: any) => prev ? [...prev, cnj.id] : [cnj.id]);
                        cnjs?.push(cnj.id);
                      });
                    } else {
                      local.conjuntosList.forEach((cnj: any) => {
                        setConjuntosArray((prev: any) => prev?.filter((el: any) => el !== cnj.id));
                        cnjs.push(cnj.id);
                      });
                    }
                  }}
                />}
                label={local.nome} />
            </FormGroup>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SearchInput search={search}
            setSearch={setSearch}
            arrayLenght={local.conjuntosList?.length}
            name={'Conjuntos:'} />
          <Typography>
            {paginated
              ?.sort((a: conjunto, b: conjunto) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : - 1; })
              ?.map((conjunto: conjunto, index: number) => (
                <Conjuntos
                  conjunto={conjunto}
                  conjuntosArray={conjuntosArray}
                  setConjuntosArray={setConjuntosArray}
                  disabled={disabled}
                />
              ))}
          </Typography>
          {(local.conjuntosList.length > 5 && !search)
            &&
            <Stack
              width={'100%'}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Pagination
                count={count}
                size="small"
                page={page}
                variant='text'
                shape='circular'
                onChange={handleChange}
              />
            </Stack>
          }
        </AccordionDetails>
      </Accordion >
    </>
  );
};

const Conjuntos = ({
  conjunto,
  conjuntosArray,
  setConjuntosArray,
  disabled
}: {
  conjunto: conjunto,
  conjuntosArray: string[],
  setConjuntosArray: Function,
  disabled: boolean
}) => {

  return (
    <FormGroup key={conjunto.id}>
      <FormControlLabel
        control={<Checkbox
          disabled={disabled}
          checked={conjuntosArray.length > 0 && conjuntosArray?.includes(conjunto.id)}
          onChange={(event) => {
            const cnjs: string[] = [];
            if (event.target.checked) {
              setConjuntosArray((prev: any) => prev ? [...prev, conjunto.id] : [conjunto.id]);
              cnjs.push(conjunto.id);
            } else {
              setConjuntosArray((prev: any) => prev.filter((ele: any) => ele !== conjunto.id));
              cnjs.push(conjunto.id);
            }
          }}
        />} label={conjunto.nome} />
    </FormGroup>
  );
};

const SearchInput = ({
  search,
  setSearch,
  arrayLenght,
  name }: {
    search: string,
    setSearch: Function,
    arrayLenght: number,
    name: string
  }) => {
  return (
    <Stack
      width={'100%'}
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-end"
      spacing={2}
      sx={{ marginBottom: '10px' }}
    >
      <Typography variant='subtitle1'>
        {name}
      </Typography>
      {arrayLenght > 5
        && <TextField
          fullWidth
          onClick={() => trackEventMatomo('modal associação de local', 'click', 'input', 'edita valor')}
          value={search}
          onChange={(eve) => setSearch(eve.target.value
            ?.normalize("NFD")
            ?.replace(/[\u0300-\u036f]/g, "")
            ?.toLowerCase())}
          label='Pesquisar'
        />}
    </Stack>
  );
};
